import { getScreenType } from '@bridebook/web/app-basic/lib/app/selectors';
import {
  getIsVenue,
  getSupplier,
  getSupplierCountry,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { A, Box, Pill } from '@bridebook/ui';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { IBreadcrumbItem } from '@bridebook/web/app-shared/lib/types';
import componentStyles from './related-locations-container.style';

interface IProps {
  breadcrumbsData: IBreadcrumbItem[];
}

const RelatedLocationsContainer = ({ breadcrumbsData }: IProps) => {
  const { t } = useTranslation('supplier');
  const supplier = useSelector(getSupplier);
  const isVenue = useSelector(getIsVenue);
  const l10nCountryCode = useSelector(getSupplierCountry);
  const countryCode = supplier?.address?.country || l10nCountryCode;
  const market = useMarket();
  const { isMobile, isTablet } = useSelector(getScreenType);
  const styles = componentStyles({ compactMode: isMobile || isTablet });

  if (!isVenue || l10nCountryCode !== countryCode) {
    return null;
  }

  const locations = breadcrumbsData.filter(({ id }) => id === 'county' || id === 'town');

  return (
    <Box as="section" style={styles.wrapper}>
      <Box style={styles.pillsWrapper}>
        {locations.map((location) => (
          <Link
            key={location.path}
            href={`/${market.prefix}${location.path}`}
            legacyBehavior
            passHref>
            <A noUnderline>
              <Pill bordered sidePaddings={12} height={35} style={styles.pill}>
                {t('seo.location.weddingVenues', { location: location.name })}
              </Pill>
            </A>
          </Link>
        ))}
      </Box>
    </Box>
  );
};

export default RelatedLocationsContainer;
